import {css} from "styled-components"
import {greys} from "../../global/colors"
import {Lato} from "../../global/fonts"

export const bodyText = css`
  ${Lato}
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: ${greys.mediumDark};
`
